import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import { jsx, jsxs } from 'react/jsx-runtime';
import { Close, BackArrow } from '@dls/assets/icons';
import { Grid, theme as theme$1, Row, Column } from '@dls/web';
import styled from 'styled-components';
import theme from '../../../../../theme/index.js';
const HamburgerMenuHeader = _ref => {
  let {
    isFirstLevel,
    onBack,
    onClose
  } = _ref;
  return /* @__PURE__ */jsx(SCHamburgerHeader, {
    isDark: !isFirstLevel,
    children: /* @__PURE__ */jsxs(Row, {
      middle: "xs",
      children: [/* @__PURE__ */jsx(Column, {
        children: !isFirstLevel && /* @__PURE__ */jsx(SCMenuBackIcon, {
          size: 24,
          onClick: onBack,
          isDark: !isFirstLevel
        })
      }), /* @__PURE__ */jsx(Column, {
        children: /* @__PURE__ */jsx(SCMenuCloseIcon, {
          size: 24,
          onClick: onClose,
          isDark: !isFirstLevel
        })
      })]
    })
  });
};
const SCHamburgerHeader = styled(Grid)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 68px;\n  padding-top: 0;\n  padding-bottom: 0;\n  transition: all 150ms ease-in-out;\n  background-color: ", ";\n  & > div {\n    height: 100%;\n  }\n"])), props => props.isDark ? theme.colours.darkslate : "unset");
const SCMenuCloseIcon = styled(Close)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  float: right;\n\n  & path {\n    fill: ", ";\n  }\n"])), props => props.isDark ? theme$1.main.colours.white : theme$1.main.colours.tertiary.l2);
const SCMenuBackIcon = styled(BackArrow)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  & path {\n    fill: ", ";\n  }\n"])), props => props.isDark ? theme$1.main.colours.white : theme$1.main.colours.tertiary.l2);
export { HamburgerMenuHeader as default };